export const componentMap = {
    'App.Page.404': {
        name: 'research-404',
        action: () => import('./research-404'),
    },
    'App.Page.Main': {
        name: 'research-main',
        action: () => import('./main/research-main'),
    },
    'App.Page.Catalog': {
        name: 'research-catalog',
        action: () => import('./catalog/research-catalog'),
    },
    'App.Page.ResearchDetails': {
        name: 'research-detail',
        action: () => import('./detail/research-detail'),
        hasParams: true,
    },
};
